import axios from 'axios';

export const baseDomain = process.env.VUE_APP_BACKEND;

export const baseURL = `${baseDomain}/web/api/`;

export const Http = axios.create({
    baseURL,
    headers: { 'Content-Type': 'application/json' }
});

export const setAuthorizationHeader = (token: string | null = null) => {
    if (token) {
        Http.defaults.headers.common.Authorization = `Bearer ${token}`;
    } else {
        delete Http.defaults.headers.common.Authorization;
    }
};

export const getParams = (pairs) =>
    pairs.reduce((params, pair) => {
        if (pair.value) {
            return { ...params, [pair.key]: pair.value };
        }
        return params;
    }, {});

Http.interceptors.request.use(
    async (config: any) => {
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

Http.interceptors.response.use(
    response => {
        return response;
    },
    async (error: any) => {
        return Promise.reject(error);
    }
);

export default Http;
